<template>

  <b-container>
    <MyMainPage/>
  </b-container>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import MyMainPage from '@/views/contents/components/MyMainPage.vue'

export default {
  name: 'MainPage',
  components: {
    MyMainPage
  }
}
</script>

